/*@flow*/
import drawHandler from 'lib/leaflet-plugins/DrawHandler';
import type { DeckPropsT } from '../types';
import { useEffect, useState } from 'react';

type DrawOptionsT = {
  active: boolean,
  ready?: Function,
  onVertexAdd?: Function,
  onVertexDragEnd?: Function,
  geojson?: Object,
};

export default (props: DeckPropsT<DrawOptionsT>) => {
  const { options, owner } = props;
  const [element, setElement] = useState();
  const { ready, onVertexAdd, onVertexDragEnd, active, geojson } = options;

  useEffect(() => {
    const el = drawHandler(owner);
    el.geojson = geojson;
    el.active = active;
    // Bind events
    el.on('draw:drag', onVertexDragEnd);
    el.on('draw:vertex_added', onVertexAdd);
    ready && ready(el);

    setElement(() => el);

    return () => {
      el.disable();
      // Unbind events
      el.off('draw:drag', onVertexDragEnd);
      el.off('draw:vertex_added', onVertexAdd);
    };
  }, []);

  useEffect(() => {
    if (!element) return;
    element.geojson = geojson;
    element.active = active;
  }, [geojson, active, element]);
};
